import {useContext} from 'react';

import {PersonalityContext, PersonalityContextType} from './personality-context';

export function usePersonality(): PersonalityContextType {
    const context = useContext<PersonalityContextType>(PersonalityContext);

    if (!context) {
        throw new Error('usePersonality must be used within PersonalityProvider');
    }

    return context;
}
